import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

import { projectsMenuEvents } from 'app/modules/wallforming/components/projects-manager/types/projectsMenuEvents';

export const GenerateIfcFromPdfs = () => {
    const { t } = useTranslation();

    return (
        <Menu.Item
            leftSection={
                <Icon
                    className="action-menu-entry-decoration action-menu-entry-decoration-icon"
                    icon="picture_as_pdf"
                />
            }
            onClick={() => window.dispatchEvent(new Event(projectsMenuEvents.openPlanToIfc))}
        >
            {t('labelGenerateIfcFromPdfs')}
        </Menu.Item>
    );
};
